export default __webpack_public_path__ + "static/media/stat-icon2.323ea468.svg";